export default "__VITE_ASSET__ED75OS1Z__"